var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"identity-ad-new"},[_c('ToolBar',{attrs:{"to":"/ads","title":"New ad"}}),_c('PageContentContainer',[_c('NewForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }